import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleRansomware() {
  return (
    <BlogArticleLayout
      tag="Cybersécurité"
      title="Ransomware en entreprise : comprendre la menace et s'en protéger"
      date="13 octobre 2026"
      ctaTitle="Vérifiez votre exposition au risque ransomware"
      ctaText="Le diagnostic évalue vos sauvegardes, vos accès et vos mesures de prévention face au ransomware."
    >
      <p style={s.intro}>
        Le ransomware reste l'une des menaces les plus coûteuses pour une PME : une attaque qui chiffre vos
        données et paralyse votre activité du jour au lendemain. Comprendre comment elle se produit est la
        meilleure façon de s'en protéger.
      </p>

      <h2 style={s.h2}>Comment un ransomware s'introduit dans l'entreprise</h2>
      <p>
        Dans la grande majorité des cas, le point d'entrée n'est pas une prouesse technique : c'est un email
        de phishing ouvert par un salarié, une vulnérabilité connue mais non corrigée sur un logiciel, ou un
        accès à distance (RDP) mal protégé et exposé sur internet. L'attaquant n'a besoin que d'une seule
        porte ouverte.
      </p>

      <h2 style={s.h2}>Ce qui se passe pendant une attaque</h2>
      <p>
        Une fois introduit, le logiciel malveillant se propage sur le réseau et chiffre les fichiers
        accessibles — documents, bases de données, parfois les sauvegardes elles-mêmes si elles sont
        connectées au même réseau. Une demande de rançon s'affiche, généralement en cryptomonnaie, avec un
        délai de paiement. De plus en plus d'attaques ajoutent une double pression : les données sont aussi
        exfiltrées, avec une menace de publication si la rançon n'est pas payée.
      </p>

      <h2 style={s.h2}>Faut-il payer la rançon ?</h2>
      <p>
        Les autorités (ANSSI, gendarmerie, CNIL) recommandent de ne pas payer : rien ne garantit la
        récupération des données, cela finance les groupes criminels, et signale que votre entreprise est
        prête à payer, ce qui expose à de nouvelles attaques. La meilleure protection reste la prévention et
        la capacité à restaurer vos données sans dépendre de l'attaquant.
      </p>

      <h2 style={s.h2}>Comment s'en protéger concrètement</h2>
      <ul style={s.ul}>
        <li style={s.li}>Des sauvegardes régulières, testées, et surtout déconnectées de votre réseau principal (hors ligne ou isolées).</li>
        <li style={s.li}>Des mises à jour appliquées sans délai sur systèmes et logiciels exposés.</li>
        <li style={s.li}>Une segmentation du réseau, pour qu'une machine infectée ne compromette pas tout le système d'information.</li>
        <li style={s.li}>Une sensibilisation des équipes au phishing, qui reste le principal vecteur d'entrée — voir notre article dédié
          {' '}<Link to="/blog/phishing-entreprise-reconnaitre-prevenir" style={s.link}>sur le phishing en entreprise</Link>.</li>
      </ul>

      <h2 style={s.h2}>Si vous êtes touché malgré tout</h2>
      <p>
        La réaction dans les premières heures compte autant que la prévention en amont. Nous détaillons la
        marche à suivre dans notre article
        {' '}<Link to="/blog/que-faire-apres-cyberattaque" style={s.link}>Que faire après une cyberattaque</Link>.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleRansomware;
